import PropTypes from "prop-types";
import React from "react";
import { NumberField } from "cxa-form-field";
import IntlSelectField from "./intlSelectField";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

const NumberWithUnit = ({ question }) =>
  <div>
    <p>
      <FormattedMessage
        id={question.questionText}
        defaultMessage={question.questionText}
      />
    </p>

    {question.tag === "alcohol_per_day" &&
      <div>
        <strong>
          <FormattedMessage {...messages.whatDrinkDescription} />
        </strong>
        <div className="cxa-grid__wrapper">
          <div className="cxa-grid__item cxa-grid__item--four">
            <figure>
              <img
                src="/assets/images/wellness/13a_mix-drink.png"
                alt="1.5fl"
              />
              <figcaption>
                <FormattedMessage {...messages.mixDrinkUnitDescription} />
              </figcaption>
            </figure>
          </div>
          <div className="cxa-grid__item cxa-grid__item--four">
            <figure>
              <img src="/assets/images/wellness/13b_wine.png" alt="5fl" />
              <figcaption>
                <FormattedMessage {...messages.winDrinkUnitDescription} />
              </figcaption>
            </figure>
          </div>
          <div className="cxa-grid__item cxa-grid__item--four">
            <figure>
              <img src="/assets/images/wellness/13c_beer.png" alt="12fl" />
              <figcaption>
                <FormattedMessage {...messages.beerwinDrinkUnitDescription} />
              </figcaption>
            </figure>
          </div>
        </div>
      </div>}

    <NumberField name={`question_${question.tag}`} />
    <IntlSelectField
      items={question.units}
      valueKey="unitValue"
      labelKey="unitDisplayText"
      name={`${question.tag}_unit`}
    />
  </div>;

NumberWithUnit.propTypes = { question: PropTypes.object };

export default NumberWithUnit;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/display-types/number-with-unit.jsx